/**
 * ENUM Tipo de um documento.
 */
export enum DocumentTypeEnum {
    ELECTRONIC_SIGNATURE = 'ELECTRONIC_SIGNATURE',
}
